import { AxiosResponse } from 'axios';
import { axiosIntance } from '../../../config/ApiConfig';
import { GeneralSale } from '../../../types/generalSales/GeneralSales';

export const GeneralSaleRepository = {
  create: (form: object): Promise<AxiosResponse<GeneralSale>> => {
    return axiosIntance.post('/generalSales', form);
  },
  update: (form: object): Promise<AxiosResponse<GeneralSale>> => {
    return axiosIntance.put('/generalSales', form);
  },
  delete: (form: object): Promise<AxiosResponse<{ sucess: boolean }>> => {
    return axiosIntance.delete('/generalSales', { data: form });
  },
};
